import React from "react";
import { motion } from "framer-motion";
import { resolveSiteName } from "../../utils/siteConfig";
import { useLocalContext } from "../../context/LocalContext";
import "./ServicesPage.css";

const catalog = [
  {
    id: "printer",
    title: "Printer setup",
    desc: "Drivers, Wi‑Fi pairing, USB installs, and offline recovery for HP, Canon, Epson, and Brother.",
    href: "/printlab",
    cta: "Open printer help",
  },
  {
    id: "extender",
    title: "Wi‑Fi extender help",
    desc: "Placement, pairing, firmware, and login issues for Netgear, TP‑Link, Linksys, and D‑Link.",
    href: "/wavelab",
    cta: "Open extender help",
  },
  {
    id: "live",
    title: "Live specialist support",
    desc: "Share your model and error — a technician walks you through until the device is working.",
    href: "/contact",
    cta: "Contact support",
  },
];

const ServicesPage = () => {
  const { webinfo = {} } = useLocalContext();
  const brand = resolveSiteName(webinfo);

  return (
    <section className="sp">
      <div className="sp__wrap">
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}>
          <p className="sp__kicker">{brand} services</p>
          <h1>Everything you need to finish the setup</h1>
          <p className="sp__lead">
            Guided flows for printers and Wi‑Fi extenders, plus live help when an error blocks the path.
          </p>
        </motion.div>

        <div className="sp__grid">
          {catalog.map((item, i) => (
            <motion.article
              key={item.id}
              className="sp__card"
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.06 }}
            >
              <h2>{item.title}</h2>
              <p>{item.desc}</p>
              <a href={item.href}>{item.cta} →</a>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesPage;
